module.exports = __webpack_public_path__ + "static/media/8OLA17.b790dac2.jpg";